module.exports = __webpack_public_path__ + "static/media/contest.6be936df.jpg";